/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateQueueSessionData
 */
export interface CreateQueueSessionData {
    /**
     * 
     * @type {string}
     * @memberof CreateQueueSessionData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateQueueSessionData
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateQueueSessionData
     */
    plannedFor?: Date;
}

/**
 * Check if a given object implements the CreateQueueSessionData interface.
 */
export function instanceOfCreateQueueSessionData(value: object): value is CreateQueueSessionData {
    return true;
}

export function CreateQueueSessionDataFromJSON(json: any): CreateQueueSessionData {
    return CreateQueueSessionDataFromJSONTyped(json, false);
}

export function CreateQueueSessionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateQueueSessionData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'plannedFor': json['plannedFor'] == null ? undefined : (new Date(json['plannedFor'])),
    };
}

export function CreateQueueSessionDataToJSON(json: any): CreateQueueSessionData {
    return CreateQueueSessionDataToJSONTyped(json, false);
}

export function CreateQueueSessionDataToJSONTyped(value?: CreateQueueSessionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'plannedFor': value['plannedFor'] == null ? value['plannedFor'] : value['plannedFor'].toISOString(),
    };
}

